// extracted by mini-css-extract-plugin
export var drawerPaper = "_3g-0";
export var itemCard = "_3g-1";
export var itemImage = "_3g-2";